export const addCartAction = (payload) => ({
    type: 'addCart',
    payload
});